import { CheckboxBase } from '@app/components/CheckboxBase/CheckboxBase';
import { useModelContext } from '@app/contexts/model';
import { useStorageConfirmTranslateContext } from '@app/modules/ConfirmTranslate/contexts/storage';
import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { Stack } from '@mui/system';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';
interface IModalConfirmProps {}

export const ModalConfirm: FunctionComponent<IModalConfirmProps> = observer<FunctionComponent<IModalConfirmProps>>(function () {
    const { translateStore } = useStorageTranslateContext();
    const { langFilesAcceptedModel } = useModelContext();
    const { confirmTranslateStore } = useStorageConfirmTranslateContext();

    let openConfirm = translateStore.openConfirm;

    const accept = () => {
        return langFilesAcceptedModel
            .saveUsersTranslation({
                accept: true,
                lang: confirmTranslateStore.languageToAccept == '' ? translateStore.targetLanguageId : confirmTranslateStore.languageToAccept,
                fileId: confirmTranslateStore.fileId,
                remove: translateStore.confirmTempFilesToDelete
            })
            .then(
                (value) => {
                    return value;
                },
                (reason) => {
                    return Promise.reject(reason);
                }
            );
    };

    return (
        <Dialog open={openConfirm} onClose={() => translateStore.handleCloseConfirm()} aria-describedby='alert-dialog-description'>
            <DialogContent>
                <DialogContentText variant={'h6'} mb={2} id='alert-dialog-description'>
                    Accept translation file?
                </DialogContentText>
                <Stack alignItems={'center'} direction={'row'} gap={1}>
                    <CheckboxBase
                        onChange={() => {
                            translateStore.confirmTempFilesToDelete = !translateStore.confirmTempFilesToDelete;
                        }}
                        description={'Delete temporary file'}
                        value={translateStore.confirmTempFilesToDelete}
                        checked={translateStore.confirmTempFilesToDelete}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        translateStore.handleCloseConfirm();
                    }}
                    size={'small'}
                    color='error'>
                    No
                </Button>
                <Button
                    onClick={() => {
                        accept().then(
                            () => {
                                translateStore.handleCloseConfirmDone();
                            },
                            (reason) => translateStore.handleOpenConfirmModalError()
                        );
                    }}
                    size={'small'}
                    color='primary'>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
});
